// extracted by mini-css-extract-plugin
export default {"reportsModeSwitch":"reports-page_reportsModeSwitch__AcOxu","reportsToolbar":"reports-page_reportsToolbar__5PWpL"};